// contexts/index.js
import React from "react";
import { PredictionProvider } from "./PredictionContext";

const AppProviders = ({ children }) => {
  return <PredictionProvider>{children}</PredictionProvider>;
};

export default AppProviders;
